webpackJsonp([264598414423048],{

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var sections = _ref.sections;
	    return _react2.default.createElement(
	        "div",
	        null,
	        sections.map(function (section, index) {
	            if (index % 2 == 0) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "section" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "columns" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "column is-6" },
	                            _react2.default.createElement("img", { src: section.image })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "column is-6" },
	                            _react2.default.createElement(
	                                "h2",
	                                null,
	                                section.title
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                null,
	                                section.description
	                            )
	                        )
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "section" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "columns" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "column is-6", style: { textAlign: 'right' } },
	                            _react2.default.createElement(
	                                "h2",
	                                null,
	                                section.title
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                null,
	                                section.description
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "column is-6" },
	                            _react2.default.createElement("img", { src: section.image })
	                        )
	                    )
	                );
	            }
	        })
	    );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.aboutPageQuery = exports.AboutPageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(11);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Content = __webpack_require__(8);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Team = __webpack_require__(16);
	
	var _Team2 = _interopRequireDefault(_Team);
	
	var _ResourceList = __webpack_require__(18);
	
	var _ResourceList2 = _interopRequireDefault(_ResourceList);
	
	var _Contact = __webpack_require__(12);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _Sections = __webpack_require__(214);
	
	var _Sections2 = _interopRequireDefault(_Sections);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPageTemplate = exports.AboutPageTemplate = function AboutPageTemplate(_ref) {
	  var title = _ref.title,
	      headerImage = _ref.headerImage,
	      headerTitle = _ref.headerTitle,
	      content = _ref.content,
	      contentComponent = _ref.contentComponent,
	      sections = _ref.sections,
	      team = _ref.team,
	      resources = _ref.resources;
	
	  var PageContent = contentComponent || _Content2.default;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: "San Juan Software | " + title
	    }),
	    _react2.default.createElement(
	      'section',
	      { className: 'hero header-image-hero sub-page-hero' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body', style: { backgroundImage: 'url(' + headerImage + ')' } },
	        _react2.default.createElement(
	          'h1',
	          { className: 'title' },
	          _react2.default.createElement(
	            'span',
	            { className: 'type-it' },
	            headerTitle
	          )
	        )
	      )
	    ),
	    _react2.default.createElement('section', { className: 'hero hero-bar is-primary' }),
	    _react2.default.createElement(
	      'section',
	      { id: 'vision-and-values', className: 'section section--gradient' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-10 is-offset-1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'section content' },
	              _react2.default.createElement(PageContent, { content: content })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'company', className: 'section content is-sjs-white-smoke' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-10 is-offset-1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'columns' },
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-6' },
	                _react2.default.createElement(
	                  'figure',
	                  { style: { float: 'right', margin: '0', textAlign: 'right' }, className: 'image' },
	                  _react2.default.createElement('img', { src: '/img/about/CES.jpg' }),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'em',
	                      null,
	                      'Tim Gillman and Drew Gislason answer questions at the ZigBee booth at CES'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-6' },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'The Company'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Over the past 15 years San Juan Software has worked closely with semiconductor companies and standards organizations to create and improve wired and wireless communications protocols that form a backbone of the internet of Things. Through products, training and services to Original Equipment Manufacturers (OEMs) San Juan Software promotes the widespread adoption of wired and wireless sensor networks for the Internet of Things (IoT) and Aerospace.'
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'management-team', className: 'section content section--gradient' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-10 is-offset-1' },
	            _react2.default.createElement(_Team2.default, { members: team.members })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'hero is-secondary' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-10 is-offset-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'section content' },
	                _react2.default.createElement(_ResourceList2.default, { resources: resources })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'hero is-sjs-white-smoke' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-10 is-offset-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'section content' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'resource' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'columns is-v-centered' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'column is-6', style: { textAlign: 'right' } },
	                      _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Drew attended and now is an instructor at the University of Washington.'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'column is-6' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.pce.uw.edu/certificates/internet-of-things', target: '_blank' },
	                        _react2.default.createElement('img', { src: '/img/about/uw-professional-logo.jpg' })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'hero is-sjs-dark-gray' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-10 is-offset-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'section content has-text-centered' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'has-text-centered' },
	                  'Are you interested in joining our team?',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { className: 'button is-large is-sjs-yellow', to: '/careers' },
	                  'Careers'
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Contact2.default, null)
	  );
	};
	
	exports.default = function (_ref2) {
	  var data = _ref2.data;
	  var _data$markdownRemark = data.markdownRemark,
	      frontmatter = _data$markdownRemark.frontmatter,
	      html = _data$markdownRemark.html;
	
	
	  return _react2.default.createElement(AboutPageTemplate, {
	    contentComponent: _Content.HTMLContent,
	    title: frontmatter.title,
	    headerImage: frontmatter.headerImage,
	    headerTitle: frontmatter.headerTitle,
	    content: html,
	    sections: frontmatter.sections,
	    team: frontmatter.team,
	    resources: frontmatter.resources
	  });
	};
	
	var aboutPageQuery = exports.aboutPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-about-page-js-ea8cf5b99853212eb1a7.js